<template>
    <div class="modal">
        <div class="modal-container" v-if="account">
            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>Manage Pro</h1>
            </div>

            <div class="modal-body no-pad">
                <div class="account-body">
                    <div class="flex items-center mb-2">
                        <CheckBox v-model="account.pro" val="1" />
                        <label class="inline-block text-gray-800 text-sm ml-2">Pro Enabled?</label>
                    </div>
                    <div class="form-field">
                        <label>Subdomain</label>
                        <input type="text" :readonly="!account.pro" class="form-field no-transform" v-model="account.subdomain">
                        <p><span class="text-sm text-gray">They'll access the CRM from {{ account.subdomain ? account.subdomain : 'subdomain' }}.crm.journolink.net</span></p>
                    </div>
                    <div class="form-field">
                        <label>Account Name</label>
                        <input type="text" :readonly="!account.pro" class="form-field no-transform" v-model="account.name">
                        <p><span class="text-sm text-gray">The name of the agency, or overarching business</span></p>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">

                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>

                        <button
                            class="btn-primary"
                            type="button"
                            @click="saveForm"
                        >Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ManagePro',
    props: {
        account: {
            type: Object,
            required: true,
        },
    },
    methods: {
        saveForm() {
            axios.post(route('accounts.update', this.$route.params.accountId), {
                pro: this.account.pro,
                name: this.account.name,
                subdomain: this.account.subdomain,
            }).then(response => {
                this.$bus.$emit('alert.success', 'Update Success')
                this.closeView()
            })
                .catch(e => {
                    this.$bus.$emit('alert.danger', e.response?.data?.message ?? 'Update Failed')
                });
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.$root.goBack()
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
    }
}
</script>

<style lang="less">
.modal-body {
    h2, h3 {
        text-transform: uppercase;
        font-size: 1.2em;
        letter-spacing: .08em;
        color: #34495e;
        margin-bottom: 10px;
    }
}
</style>
